<script>
export default {
  name: 'AccordionGroup',
  props: {
    queryParam: {
      type: String,
      required: false,
    },
    id: {
      type: String,
      required: false,
    },
    deSelectable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selected: this.id,
    };
  },
  mounted() {
    this.openOnLoad();
  },
  methods: {
    openOnLoad() {
      if (!this.queryParam) {
        return;
      }
      let params = new URLSearchParams(window.location.search);
      if (params.has(this.queryParam)) {
        this.selected = params.get(this.queryParam);
      }
    },
    toggle(id) {
      id = id.toString();
      this.selected = this.deSelectable
        ? this.selected === id
          ? null
          : id
        : (this.selected = id);
    },
    isSelected(id) {
      return this.selected === id.toString();
    },
  },
  render(createElement) {
    return createElement('div', {}, [
      this.$scopedSlots.default({
        toggle: this.toggle,
        isSelected: this.isSelected,
      }),
    ]);
  },
};
</script>
